{
  "pricing": {
    "levels": {
      "RETAIL": "Retail",
      "WHOLESALE": "Wholesale",
      "DISTRIBUTOR": "Distributor"
    },
    "levelHints": {
      "RETAIL": "Selling by the piece",
      "WHOLESALE": "Selling in quantity",
      "DISTRIBUTOR": "Large quantities for traders and distributors"
    },
    "prices": {
      "RETAIL": "Retail price",
      "WHOLESALE": "Wholesale price",
      "DISTRIBUTOR": "Distributor price",
      "CUSTOM": "Custom price"
    },
    "sources": {
      "RETAIL": "Retail",
      "WHOLESALE": "Wholesale",
      "DISTRIBUTOR": "Distributor",
      "CUSTOM": "Custom"
    },
    "customHint": "A special price set for a specific customer or group",
    "unit": "Unit",
    "unitOf": "Unit of line {{n}}",
    "packOf": "{{factor}} × {{base}}",
    "baseUnit": "Base unit"
  },
  "lookup": {
    "search": "Name, SKU or barcode…",
    "hint": "Type a name, SKU or barcode, or scan a barcode.",
    "empty": "No product matches.",
    "failed": "Products couldn't be loaded. Try again.",
    "service": "Service",
    "lastCost": "Last cost",
    "averageCost": "Average",
    "noCost": "Never bought"
  },
  "status": {
    "ACTIVE": "Active",
    "INACTIVE": "Inactive",
    "ARCHIVED": "Archived"
  },
  "type": {
    "GOODS": "Goods",
    "SERVICE": "Service"
  },
  "leave": {
    "title": "Discard unsaved changes?",
    "body": "You have changes on this page that haven't been saved.",
    "confirm": "Discard changes",
    "cancel": "Keep editing"
  },
  "errors": {
    "PRODUCT_ARCHIVED": "An archived product can't be edited. Restore it first.",
    "PRODUCT_HAS_STOCK": "This product has stock movements, so its type, unit and serial tracking can no longer change.",
    "UNIT_IN_USE": "Products use this unit. Move them to another unit first; a unit that allows decimals can't be switched to whole units while products use it.",
    "UNIT_SYMBOL_TAKEN": "Another unit now has this symbol. Change its symbol, or this one, first.",
    "ATTRIBUTE_IN_USE": "Product variants use this attribute. Only an attribute no variant uses can be archived.",
    "VALUE_IN_USE": "A value that product variants use can't be removed. Rename it instead.",
    "CATEGORY_HAS_CHILDREN": "This category has sub-categories. Archive or move them first.",
    "CATEGORY_PARENT_ARCHIVED": "Restore its parent category first.",
    "PRODUCT_HOLDS_STOCK": "This product still has stock. Adjust or transfer it to zero before archiving it.",
    "PRODUCT_HOLDS_STOCK_INVENTORY_OFF": "This product still has {{quantity}} in stock, and stock can't be adjusted or transferred while Inventory is turned off for your company. Ask your provider to turn Inventory back on, bring the stock to zero, then archive the product.",
    "PRODUCT_HOLDS_STOCK_INVENTORY_OFF_SHORT": "This product's stock isn't at zero: {{quantity}} on hand and {{short}} below zero across its warehouses. Stock can't be adjusted or transferred while Inventory is turned off for your company. Ask your provider to turn Inventory back on, bring the stock to zero, then archive the product.",
    "VARIANT_HOLDS_STOCK": "A variant you removed still has stock. Adjust or transfer it to zero first.",
    "CATEGORY_IN_USE": "Active products use this category. Move them to another category first.",
    "CUSTOM_PRICE_OVERLAP": "This customer or group already has a custom price for this product and unit on these dates. Change the dates, or edit that price instead.",
    "PACK_HAS_CUSTOM_PRICES": "Custom prices are set for this pack at its current size, and they would apply to the new size as they are. Change or remove them on the product's page, then change how many the pack holds.",
    "UNIT_ARCHIVED": "This product is sold in an archived unit. Restore {{units}} first, then the product.",
    "UNIT_ARCHIVED_ANY": "This product is sold in an archived unit. Restore that unit first, then the product.",
    "SKU_TAKEN": "A SKU is already used by another product. Change it and save again.",
    "BARCODE_TAKEN": "A barcode is already used by another product. Change it and save again.",
    "PRODUCT_NOT_ARCHIVED": "Only an archived product can give up its SKUs and barcodes. Change the code instead."
  },
  "messages": {
    "packHoldsMore": "A pack holds more than one base unit",
    "packFactor": "Enter how many base units the pack holds",
    "packBoth": "Give both how many it holds and the unit",
    "otherUnit": "Choose another active unit",
    "activeUnit": "Choose an active unit",
    "serialPacks": "A serial-tracked product is bought and sold one by one, so it can't have packs",
    "packBaseUnit": "A pack needs a unit other than the product's own",
    "packTwice": "Add each pack unit once",
    "priceUnit": "Price a unit the product is sold in",
    "baseRetail": "The base unit's Retail price is the variant's price",
    "priceTwice": "Give each price once",
    "choosePack": "Choose one of the packs",
    "onePackBarcode": "One barcode per pack",
    "barcodeInUse": "This barcode is already in use",
    "chooseScope": "Choose a customer or a customer group",
    "chooseGroup": "Choose a customer group",
    "overlap": "Overlaps another custom price",
    "notSoldInUnit": "This product isn't sold in this unit",
    "packHasCustomPrices": "Custom prices are set for this pack at its current size",
    "walkInRetail": "The walk-in customer always buys at the Retail price"
  },
  "prices": {
    "title": "Prices",
    "variant": "Variant",
    "table": "Prices by unit and level",
    "tableOf": "Prices of {{variant}}",
    "follows": "(not set: follows the Retail price)",
    "legendSet": "Set on the product",
    "legendFallback": "Follows the Retail price"
  },
  "customPrices": {
    "title": "Custom prices",
    "add": "Add custom price",
    "retry": "Try again",
    "failed": "The custom prices couldn't be loaded.",
    "empty": "No custom prices yet. Give a customer or a customer group its own price for this product: it beats the Retail, Wholesale and Distributor prices on their documents.",
    "intro": "This price beats the Retail, Wholesale and Distributor prices on the customer's documents.",
    "fields": {
      "for": "For",
      "customer": "Customer",
      "group": "Customer group",
      "variant": "Variant",
      "price": "Price",
      "valid": "Valid",
      "validFrom": "Valid from",
      "validTo": "Valid until",
      "notes": "Notes"
    },
    "scope": {
      "CUSTOMER": "A customer",
      "GROUP": "A customer group"
    },
    "actions": "Actions",
    "groupStamp": "Group",
    "expired": "Expired",
    "upcoming": "Upcoming",
    "editNamed": "Edit the custom price of {{name}}",
    "deleteNamed": "Delete the custom price of {{name}}",
    "delete": {
      "title": "Delete this custom price?",
      "body": "{{name}} goes back to the price of their level for this product.",
      "confirm": "Delete"
    },
    "toast": {
      "created": "Custom price added",
      "updated": "Custom price saved",
      "deleted": "Custom price deleted"
    },
    "between": "{{from}} – {{to}}",
    "from": "From {{date}}",
    "until": "Until {{date}}",
    "always": "Always",
    "errors": {
      "notSaved": "The custom price wasn't saved",
      "version": "Someone else changed this custom price. Close this panel and open it again."
    },
    "newTitle": "New custom price",
    "editTitle": "Edit custom price",
    "save": "Save custom price",
    "hints": {
      "groupAccess": "Choosing a group needs access to customers.",
      "unit": "A price for the base unit applies to packs too, times what they hold, unless a pack has a price of its own.",
      "price": "Before tax, per {{unit}}.",
      "priceRetail": "Before tax, per {{unit}}. The Retail price is {{retail}}.",
      "dates": "Leave the dates empty for a price that starts now and never ends."
    },
    "chooseGroup": "Choose a group",
    "noGroups": "No customer groups yet",
    "fromNow": "From now",
    "noEnd": "No end"
  },
  "products": {
    "title": "Products",
    "subtitle": "Goods you stock and services you sell, with their prices, SKUs and barcodes.",
    "new": "New product",
    "newTitle": "New product",
    "newSubtitle": "Goods are stocked and counted; services are only sold.",
    "editTitle": "Edit {{name}}",
    "editSubtitle": "Edit product",
    "save": "Save product",
    "saveHint": "Press {{shortcut}} to save",
    "views": "Product views",
    "view": {
      "current": "All",
      "active": "Active",
      "inactive": "Inactive",
      "archived": "Archived"
    },
    "searchPlaceholder": "Search name, SKU or barcode…",
    "searchLabel": "Search products",
    "clearSearch": "Clear search",
    "typeFilter": "Type",
    "allTypes": "All types",
    "categoryFilter": "Category",
    "allCategories": "All categories",
    "sortLabel": "Sort",
    "sort": {
      "nameAsc": "Name A–Z",
      "nameDesc": "Name Z–A",
      "newest": "Newest first",
      "oldest": "Oldest first",
      "onHandAsc": "On hand, lowest first",
      "onHandDesc": "On hand, highest first",
      "priceAsc": "Price, lowest first",
      "priceDesc": "Price, highest first"
    },
    "tableLabel": "Products",
    "clearFilters": "Clear filters",
    "empty": {
      "title": "No products yet.",
      "body": "Add the goods and services you sell.",
      "filteredTitle": "No products match.",
      "filteredBody": "Try another search, type or category, or clear the filters.",
      "view": {
        "active": "No active products.",
        "inactive": "No inactive products.",
        "archived": "No archived products."
      },
      "stock": {
        "low": "Nothing is at or below its reorder level.",
        "out": "Nothing has run out."
      }
    },
    "sections": {
      "identity": "Product",
      "classification": "Classification and tax",
      "pricing": "Price and stock",
      "overview": "Overview",
      "record": "Record",
      "variants": "Variants",
      "price": "Price and tax",
      "stockUnits": "Stock and units",
      "codes": "Barcode and SKU",
      "prices": "Prices and tax"
    },
    "packs": {
      "label": "Packs",
      "hint": "Also sold or bought in bigger units, such as a carton of 12. Stock is always counted in {{unit}}.",
      "hintNoUnit": "Also sold or bought in bigger units, such as a carton of 12. Stock is always counted in the base unit.",
      "serialHint": "Serial-tracked products are bought and sold one by one, so they have no packs.",
      "add": "Add pack",
      "remove": "Remove pack {{n}}",
      "unitOf": "Unit of pack {{n}}",
      "factorOf": "Content of pack {{n}} ({{unit}})",
      "holds": "holds",
      "chooseUnit": "Choose a unit",
      "listed": "Packs: {{packs}}"
    },
    "grid": {
      "label": "Prices",
      "labelOfVariant": "Prices of variant {{n}}",
      "cell": "{{level}} per {{unit}}",
      "cellOfVariant": "{{level}} per {{unit}}, variant {{n}}",
      "barcode": "Pack barcode",
      "barcodeOf": "Barcode of {{unit}}",
      "barcodeOfVariant": "Barcode of {{unit}}, variant {{n}}",
      "fallback": "An empty cell uses the price shown in grey: a pack sells at the base unit's price times what it holds, and Wholesale and Distributor sell at the Retail price until you set theirs.",
      "fallbackDiscount": "An empty cell uses the price shown in grey: a pack sells at the base unit's price times what it holds, Wholesale at the Retail price less {{wholesale}}% and Distributor less {{distributor}}%.",
      "levelsHeader": "Levels",
      "levelsShort": "Prices",
      "levelsSet": "{{n}} set",
      "toggleOfVariant": "Prices by level, variant {{n}}"
    },
    "custom": {
      "noteNew": "A special price for one customer or a customer group. Set it on the product's page once the product is saved.",
      "noteEdit": "A special price for one customer or a customer group, set on the product's page.",
      "open": "Open custom prices"
    },
    "fields": {
      "name": "Name",
      "nameAr": "Name in Arabic",
      "description": "Description",
      "type": "Type",
      "status": "Status",
      "category": "Category",
      "subcategory": "Sub-category",
      "unit": "Unit",
      "taxRate": "Tax rate",
      "trackSerials": "Track serial numbers",
      "hasVariants": "This product comes in variants",
      "price": "Price",
      "reorderLevel": "Reorder level",
      "sku": "SKU",
      "barcode": "Barcode",
      "attributes": "Attributes",
      "variant": "Variant",
      "variantName": "Name (optional)",
      "variantNameAr": "Arabic name (optional)",
      "variantCount": "Variants",
      "default": "Default",
      "createdAt": "Created",
      "updatedAt": "Last changed",
      "onHand": "On hand"
    },
    "typeHint": {
      "GOODS": "Stocked in warehouses, with quantities and costs.",
      "SERVICE": "Sold only; no stock is kept."
    },
    "hints": {
      "structural": "Once stock has moved, the type, unit and serial tracking can't change.",
      "status": "Inactive products stay on record but aren't offered on new documents.",
      "taxRate": "Suggested on document lines for this product.",
      "trackSerials": "Each unit carries its own serial number.",
      "pricingGoods": "Selling price excluding tax, the codes printed or scanned, and when to restock.",
      "pricingService": "Selling price excluding tax, and the codes used to find the service.",
      "hasVariants": "Sizes, colours and the like: each variant has its own SKU, barcode, price and stock.",
      "price": "Excluding tax.",
      "reorderLevel": "Stock at or below this level is flagged.",
      "reorderLevelIn": "In {{unit}}. Stock at or below this level is flagged.",
      "barcode": "Scan it into the field, or type it.",
      "attributes": "Up to {{max}}, such as colour and size.",
      "variants": "Leave a name empty to use the values (\"Red / L\"). Prices exclude tax."
    },
    "noCategory": "No category",
    "searchCategories": "Search categories…",
    "noCategories": "No category matches.",
    "clearCategory": "No category",
    "noSubcategory": "No sub-category",
    "searchSubcategories": "Search sub-categories…",
    "noSubcategories": "No sub-category matches.",
    "chooseUnit": "Choose a unit",
    "noTax": "No tax",
    "chooseAttributes": "Choose attributes",
    "searchAttributes": "Search attributes…",
    "noAttributes": "No attributes yet. Add them under Attributes.",
    "clearAttributes": "Clear",
    "chooseValue": "Choose",
    "variantsTable": "Variants",
    "addVariant": "Add variant",
    "removeVariant": "Remove variant {{n}}",
    "variantActions": "Variant actions",
    "valueOfVariant": "{{attribute}} of variant {{n}}",
    "nameOfVariant": "Name of variant {{n}}",
    "nameArOfVariant": "Arabic name of variant {{n}}",
    "skuOfVariant": "SKU of variant {{n}}",
    "barcodeOfVariant": "Barcode of variant {{n}}",
    "priceOfVariant": "Price of variant {{n}}",
    "reorderOfVariant": "Reorder level of variant {{n}}",
    "defaultVariant": "Variant {{n}} is the default",
    "defaultStamp": "Default",
    "generate": {
      "action": "Generate variants…",
      "title": "Generate variants",
      "body": "Choose values for each attribute. Every combination the product doesn't have yet is added, with the first variant's price.",
      "confirm_one": "Add {{count}} variant",
      "confirm_other": "Add {{count}} variants",
      "chooseValues": "Choose values",
      "searchValues": "Search values…",
      "noValues": "No value matches.",
      "clear": "Clear",
      "selected": "{{n}} selected"
    },
    "errors": {
      "notSaved": "The product wasn't saved",
      "chooseUnit": "Choose a unit",
      "chooseAttribute": "Choose at least one attribute",
      "tooManyAttributes": "Choose up to {{max}} attributes",
      "chooseValue": "Choose a value for every attribute",
      "duplicateCombination": "Another variant has the same values",
      "duplicateSku": "Another variant already uses this SKU",
      "duplicateBarcode": "Another variant already uses this barcode",
      "activeUnit": "Choose an active unit",
      "activeCategory": "Choose an active category",
      "serviceSerials": "Services aren't stocked and can't track serial numbers",
      "skuTaken": "A SKU is already used by another product. Change it and save again.",
      "barcodeTaken": "A barcode is already used by another product. Change it and save again.",
      "serialPacks": "Remove the packs: a serial-tracked product is bought and sold one by one",
      "packBaseUnit": "Choose a unit other than the product's own",
      "packTwice": "This unit is already a pack",
      "packFactor": "Enter how many base units the pack holds"
    },
    "codeHolder": {
      "titleSku": "This SKU is already taken",
      "titleBarcode": "This barcode is already taken",
      "archivedSku": "The SKU {{code}} belongs to {{name}}, an archived product.",
      "archivedBarcode": "The barcode {{code}} belongs to {{name}}, an archived product.",
      "activeSku": "The SKU {{code}} belongs to {{name}}. Change it here, or on that product, then save again.",
      "activeBarcode": "The barcode {{code}} belongs to {{name}}. Change it here, or on that product, then save again.",
      "releaseNote": "Restore that product to use it again, or free its codes for this one: its SKUs get “-ARC-” and a short id added, its barcodes are cleared, and it stays archived.",
      "askArchiver": "Ask someone who can archive products to restore it or free its codes, or change the code here.",
      "restore": "Restore it",
      "release": "Free the code and save",
      "open": "Open {{name}}",
      "back": "Back to the form"
    },
    "conflict": {
      "title": "Someone else changed this product",
      "body": "Reload to get their changes. Your edits on this page will be replaced.",
      "reload": "Reload"
    },
    "archivedTitle": "This product is archived",
    "backToProduct": "Back to product",
    "archive": "Archive",
    "restore": "Restore",
    "archiveDialog": {
      "title": "Archive {{name}}?",
      "body": "It disappears from lists and pickers. Its documents and stock history stay; you can restore it later."
    },
    "restoreDialog": {
      "title": "Restore {{name}}?",
      "body": "It becomes available on new documents again."
    },
    "movements": "Stock movements",
    "movementsOf": "Stock movements of {{name}}",
    "yes": "Yes",
    "no": "No",
    "toast": {
      "created": "{{name}} added",
      "updated": "{{name}} saved",
      "archived": "{{name}} archived",
      "restored": "{{name}} restored",
      "exported_one": "Exported {{n}} product",
      "exported_other": "Exported {{n}} products",
      "exportedView": "Exported the view"
    },
    "lowStockMarker": "At or below the reorder level",
    "notStocked": "Not stocked",
    "movementsShort": "Movements",
    "export": "Export view",
    "exportHint_one": "CSV of the {{n}} product in this view",
    "exportHint_other": "CSV of the {{n}} products in this view",
    "warehouseFilter": "Warehouse",
    "allWarehouses": "All warehouses",
    "onHandIn": "On hand in {{warehouse}}",
    "stockView": {
      "low": "Low stock",
      "out": "Out of stock"
    },
    "archiveBlocked": {
      "stock": "{{quantity}} still on hand: adjust or transfer it to zero first",
      "checking": "Checking the stock…",
      "unavailable": "The stock couldn't be loaded"
    },
    "priceTo": "to {{price}}",
    "stats": {
      "label": "Product figures",
      "active": "Active products",
      "ofAll": "of {{total}}",
      "activeShare": "{{percent}}% of the products are active",
      "stockValue": "Stock value",
      "stockValueDetail_one": "{{n}} item at cost",
      "stockValueDetail_other": "{{n}} items at cost",
      "outDetail": "Nothing on hand",
      "unavailable": "Figures unavailable",
      "products_one": "{{n}} product",
      "products_other": "{{n}} products"
    },
    "sectionHints": {
      "identity": "What the product is called and how it is filed.",
      "priceVariants": "Each variant carries its own price, set in Variants below.",
      "stockGoods": "The unit it is counted in, and when to reorder.",
      "stockService": "The unit it is sold in.",
      "codes": "For scanning at the till and on documents.",
      "price": "The selling price before tax, and the tax added on document lines.",
      "prices": "What each unit sells for at each level, before tax. Only the Retail price of the base unit is required."
    }
  },
  "units": {
    "title": "Units",
    "subtitle": "The units products are counted, sold and stocked in.",
    "new": "New unit",
    "newTitle": "New unit",
    "newSubtitle": "Such as piece, box, kilogram or litre.",
    "editTitle": "Edit unit",
    "save": "Save unit",
    "actions": "Actions",
    "showArchived": "Show archived",
    "empty": "No units yet.",
    "editNamed": "Edit {{name}}",
    "archiveNamed": "Archive {{name}}",
    "restoreNamed": "Restore {{name}}",
    "fractions": "Decimals allowed",
    "wholeOnly": "Whole units only",
    "fields": {
      "name": "Name",
      "nameAr": "Name in Arabic",
      "symbol": "Symbol",
      "symbolAr": "Symbol in Arabic",
      "allowFractions": "Allow decimal quantities",
      "status": "Status",
      "packOf": "Usual pack content",
      "usage": "Used by"
    },
    "hints": {
      "symbol": "Shown after quantities, such as pc or kg.",
      "allowFractions": "For weights and volumes (1.5 kg). Leave off for things counted whole.",
      "allowFractionsInUse": "Products use this unit, so it keeps allowing decimals.",
      "packOf": "For a pack unit such as a carton: what one usually holds. A product that adds it as a pack starts with this number, and can change it."
    },
    "packOfValue": "1 {{unit}} = {{factor}} {{base}}",
    "holds": "Holds",
    "packFactor": "How many it holds",
    "packOfUnit": "Unit it holds",
    "chooseUnit": "Choose a unit",
    "clearPackOf": "Not a pack",
    "usage": {
      "none": "No products yet",
      "baseOf_one": "{{n}} product",
      "baseOf_other": "{{n}} products",
      "packOf_one": "Pack in {{n}} product",
      "packOf_other": "Pack in {{n}} products"
    },
    "archive": {
      "title": "Archive {{name}}?",
      "body": "It can no longer be chosen for products. Only a unit no active product uses can be archived.",
      "confirm": "Archive"
    },
    "restore": {
      "title": "Restore {{name}}?",
      "body": "It can be chosen for products again.",
      "confirm": "Restore"
    },
    "errors": {
      "nameTaken": "Another unit already has this name.",
      "symbolTaken": "Another unit already has this symbol.",
      "version": "Someone else changed this unit. Close this panel and open it again."
    },
    "toast": {
      "created": "Unit added",
      "updated": "Unit saved",
      "archived": "Unit archived",
      "restored": "Unit restored"
    }
  },
  "categories": {
    "title": "Product categories",
    "subtitle": "Group products for finding and reporting. Categories can have sub-categories.",
    "new": "New category",
    "newTitle": "New category",
    "newSub": "New sub-category",
    "newSubtitle": "A top-level category, unless you choose a parent.",
    "newUnder": "Under {{name}}",
    "editTitle": "Edit category",
    "save": "Save category",
    "actions": "Actions",
    "searchPlaceholder": "Search categories…",
    "searchLabel": "Search categories",
    "clearSearch": "Clear search",
    "showArchived": "Show archived",
    "expandAll": "Expand all",
    "collapseAll": "Collapse all",
    "empty": "No categories yet.",
    "emptyFiltered": "No categories match.",
    "addUnder": "Add a category under {{name}}",
    "editNamed": "Edit {{name}}",
    "archiveNamed": "Archive {{name}}",
    "restoreNamed": "Restore {{name}}",
    "productsIn": "Products in {{name}}",
    "topLevel": "Top level",
    "makeTopLevel": "Make it a top-level category",
    "searchParent": "Search categories…",
    "noParents": "No category matches.",
    "fields": {
      "name": "Name",
      "nameAr": "Name in Arabic",
      "productCount": "Products",
      "parent": "Parent category"
    },
    "hints": {
      "parent": "Leave empty for a top-level category."
    },
    "archive": {
      "title": "Archive {{name}}?",
      "body": "It can no longer be chosen for products. A category that active products use, or that has sub-categories, can't be archived: move them first.",
      "confirm": "Archive"
    },
    "restore": {
      "title": "Restore {{name}}?",
      "body": "It can be chosen for products again. A sub-category waits for its parent to be restored.",
      "confirm": "Restore"
    },
    "errors": {
      "nameTaken": "Another category already has this name.",
      "version": "Someone else changed this category. Close this panel and open it again.",
      "loop": "A category can't be placed under itself or one of its sub-categories.",
      "activeParent": "Choose an active parent category."
    },
    "toast": {
      "created": "Category added",
      "updated": "Category saved",
      "archived": "Category archived",
      "restored": "Category restored"
    }
  },
  "attributes": {
    "title": "Attributes",
    "subtitle": "What variants differ by, such as colour or size, and the values each can take.",
    "new": "New attribute",
    "newTitle": "New attribute",
    "newSubtitle": "Such as Colour, with values Red, Blue and Black.",
    "editTitle": "Edit attribute",
    "save": "Save attribute",
    "actions": "Actions",
    "showArchived": "Show archived",
    "empty": "No attributes yet.",
    "emptyBody": "Add attributes to sell products in variants, such as sizes or colours.",
    "editNamed": "Edit {{name}}",
    "archiveNamed": "Archive {{name}}",
    "restoreNamed": "Restore {{name}}",
    "more": "+{{n}} more",
    "fields": {
      "status": "Status",
      "name": "Name",
      "nameAr": "Name in Arabic",
      "values": "Values",
      "value": "Value",
      "valueAr": "Value in Arabic"
    },
    "hints": {
      "values": "In the order they should be listed.",
      "inUse": "Renaming a value updates every variant that uses it. A value in use can't be removed."
    },
    "valueN": "Value {{n}}",
    "valueArN": "Value {{n}} in Arabic",
    "moveUp": "Move value {{n}} up",
    "moveDown": "Move value {{n}} down",
    "removeValue": "Remove value {{n}}",
    "addValue": "Add value",
    "archive": {
      "title": "Archive {{name}}?",
      "body": "It is no longer offered for new variants. Only an attribute no product variant uses can be archived.",
      "confirm": "Archive"
    },
    "restore": {
      "title": "Restore {{name}}?",
      "body": "It is offered for variants again.",
      "confirm": "Restore"
    },
    "errors": {
      "nameTaken": "Another attribute already has this name.",
      "duplicateValue": "Each value can appear only once."
    },
    "toast": {
      "created": "Attribute added",
      "updated": "Attribute saved",
      "archived": "Attribute archived",
      "restored": "Attribute restored"
    }
  },
  "actions": {
    "open": "Open",
    "adjust": "Adjust stock",
    "count": "Count stock",
    "transfer": "Transfer",
    "labels": "Print labels",
    "retryFigures": "Load the stock again",
    "rowActions": "Actions for {{name}}"
  },
  "profile": {
    "figures": "Product figures",
    "figuresFailed": "The product's figures couldn't be loaded.",
    "onHand": "On hand",
    "value": "Value at cost",
    "averageCost": "Average cost",
    "noCostYet": "No cost yet",
    "reorder": {
      "NEGATIVE": "Below zero in a warehouse",
      "OUT": "Out of stock",
      "LOW": "At or below the reorder level",
      "OK": "Above the reorder level",
      "OKAt": "Reorder at {{level}}"
    },
    "price": "Price",
    "priceExTax": "Excluding {{tax}}",
    "priceNoTax": "No tax",
    "netSalesHead": "Net sales",
    "soldQuantity": "{{quantity}} sold",
    "lastSale": "Last sale",
    "lastPurchase": "Last purchase",
    "never": "None yet",
    "serialsStamp": "Serials",
    "archivedBanner": "Archived on {{date}}. It is hidden from pickers; its documents and stock history stay.",
    "inactiveBanner": "Inactive: it isn't offered on new documents.",
    "tabs": {
      "label": "Product sections",
      "overview": "Overview",
      "stock": "Stock",
      "sales": "Sales",
      "purchases": "Purchases",
      "attachments": "Attachments",
      "serials": "Serial numbers"
    },
    "attention": {
      "title": "Needs attention",
      "none": "Nothing needs attention.",
      "unavailable": "Unavailable",
      "negative_one": "warehouse below zero",
      "negative_other": "warehouses below zero",
      "low_one": "variant at or below its reorder level",
      "low_other": "variants at or below their reorder level",
      "noCost_one": "variant held at no cost",
      "noCost_other": "variants held at no cost",
      "noBarcode_one": "variant without a barcode",
      "noBarcode_other": "variants without a barcode"
    },
    "variantCount_one": "{{n}} variant",
    "variantCount_other": "{{n}} variants",
    "heldIn_one": "Held in {{n}} warehouse",
    "heldIn_other": "Held in {{n}} warehouses",
    "weightedAverage": "Weighted over every warehouse",
    "margin": "Margin",
    "marginPerUnit": "Per unit",
    "marginOnPrice": "On the price, excluding VAT",
    "noMarginYet": "No cost to compare yet"
  },
  "stockTab": {
    "unavailable": "The stock couldn't be loaded.",
    "onHandTitle": "On hand by warehouse",
    "cellHint": "Choose a quantity to see its movements with the running balance.",
    "neverStocked": "Never stocked in any warehouse.",
    "product": "Product",
    "total": "Total",
    "averageCost": "Average cost",
    "value": "Value",
    "cellLabel": "{{variant}} in {{warehouse}}: {{quantity}}",
    "movementsTitle": "Stock movements",
    "variantFilter": "Variant",
    "allVariants": "All variants",
    "clearSelection": "Show all movements",
    "allMovements": "Open in Stock movements",
    "runningHint": "Choose one warehouse and variant to see the running balance.",
    "noMovements": "No stock movements.",
    "warehousesTitle": "Warehouses",
    "reorderAt": "Reorder level {{level}}",
    "warehouseRow": "{{warehouse}}: {{quantity}}",
    "state": {
      "low": "Low",
      "out": "Out",
      "negative": "Below zero"
    },
    "allWarehouses": "All warehouses",
    "onHand": "On hand"
  },
  "history": {
    "salesTitle": "Sales",
    "purchasesTitle": "Purchases",
    "partyHidden": "Supplier hidden",
    "hint": "Posted documents, newest first. Amounts exclude VAT; returns are negative.",
    "clearFilters": "Clear filters",
    "emptyFiltered": "No lines match.",
    "emptySales": "Not sold yet.",
    "emptyPurchases": "Not bought yet.",
    "docType": {
      "INVOICE": "Invoice",
      "DEBIT_NOTE": "Debit note",
      "CREDIT_NOTE": "Credit note",
      "PURCHASE": "Purchase",
      "SUPPLIER_RETURN": "Supplier return"
    },
    "fields": {
      "date": "Date",
      "document": "Document",
      "customer": "Customer",
      "supplier": "Supplier",
      "quantity": "Quantity",
      "unitPrice": "Unit price",
      "unitCost": "Unit cost",
      "net": "Net"
    },
    "scopeRestricted": {
      "title": "Purchase history is not available to you",
      "body": "It covers every purchase of this product, and your access is limited to part of the purchases."
    },
    "salesScopeRestricted": {
      "title": "Sales history is not available to you",
      "body": "It covers every sale of this product, and your access is limited to part of the sales documents."
    }
  },
  "labels": {
    "title": "Labels for {{name}}",
    "subtitle": "Barcode labels for the shelf or the goods.",
    "back": "Back to product",
    "print_one": "Print {{count}} label",
    "print_other": "Print {{count}} labels",
    "variantsTable": "Labels to print",
    "product": "Product",
    "code": "Code",
    "copies": "Copies",
    "copiesOf": "Copies of {{name}}",
    "format": {
      "EAN13": "EAN-13",
      "CODE128": "Code 128"
    },
    "cannotEncode": "Can't be printed as a barcode",
    "noCode": "No barcode or SKU",
    "unprintable_one": "{{count}} variant has no code that prints as a barcode. Add a barcode or SKU to it.",
    "unprintable_other": "{{count}} variants have no code that prints as a barcode. Add a barcode or SKU to them.",
    "size": "Label size",
    "sizes": {
      "roll50x25": "Roll 50 × 25 mm",
      "roll38x25": "Roll 38 × 25 mm",
      "a4x24": "A4 sheet, 24 labels (70 × 37 mm)"
    },
    "showName": "Print the name",
    "showPrice": "Print the price",
    "priceIncludes": "Prices include {{tax}}.",
    "priceNoTax": "Prices carry no tax.",
    "none": "Choose at least one copy to print.",
    "preview": "Label preview",
    "listTitle": "Labels to print",
    "optionsTitle": "Label options",
    "previewTitle": "Preview"
  }
}
